import styled from 'styled-components';
import { Breakpoints } from '../../../styled/constants';

export const LayoutWrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.background.tertiary};

  @media (min-width: ${Breakpoints.tablet}px) {
    background-color: ${({ theme }) => theme.colors.background.primary};
  }

  @media (min-width: ${Breakpoints.desktop}px) {
    width: 1000px;
    margin: auto;
  }
`;

export const HeaderWrapper = styled.div`
  @media (min-width: ${Breakpoints.tablet}px) {
    display: none;
  }
`;

export const CurrentItemContentWrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.background.tertiary};

  @media (min-width: ${Breakpoints.tablet}px) {
    padding: 0 40px;
    background-color: ${({ theme }) => theme.colors.background.primary};
    display: flex;
    flex-direction: column;
    gap: 30px;
    margin-top: 30px;
  }

  @media (min-width: ${Breakpoints.smallDesktop}px) {
    padding: 0;
  }
`;
